/* PATCH 41 — catalogue : filtres par univers et fenêtre de détail. */
(() => {
  'use strict';
  const p41t = (k, f) => { const s = window.PATCH41_STRINGS; return (s && s[k]) || f; };
  const init = root => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const tiles = Array.from(root.querySelectorAll('[data-patch-tile]'));

    /* Filtres */
    const filters = root.querySelector('[data-filters]');
    const status = root.querySelector('[data-filter-status]');
    if (filters) {
      const chips = Array.from(filters.querySelectorAll('[data-filter]'));
      const apply = (value, focusChip) => {
        let shown = 0;
        tiles.forEach(tile => {
          const visible = value === 'all' || tile.dataset.univers === value;
          tile.hidden = !visible;
          if (visible) shown++;
        });
        chips.forEach(chip => chip.setAttribute('aria-pressed', String(chip.dataset.filter === value)));
        if (status) status.textContent = (shown > 1 ? p41t('catalog_shown_other', '[count] patchs affichés') : p41t('catalog_shown_one', '[count] patch affiché')).replace('[count]', shown);
        if (focusChip) focusChip.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      };
      chips.forEach(chip => chip.addEventListener('click', () => {
        apply(chip.dataset.filter, chip);
        const url = new URL(location.href);
        if (chip.dataset.filter === 'all') url.searchParams.delete('univers'); else url.searchParams.set('univers', chip.dataset.filter);
        history.replaceState({}, '', url);
      }));
      const initial = new URLSearchParams(location.search).get('univers');
      if (initial && chips.some(c => c.dataset.filter === initial)) apply(initial);
    }

    /* Fenêtre de détail (modèles à venir) */
    const dialog = root.querySelector('[data-patch-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const img = dialog.querySelector('[data-dialog-img]');
    let opener = null;
    const open = (tile, trigger) => {
      opener = trigger;
      img.src = tile.dataset.large || '';
      img.alt = tile.dataset.alt || '';
      dialog.querySelector('[data-dialog-title]').textContent = tile.dataset.name;
      dialog.querySelector('[data-dialog-univers]').textContent = tile.dataset.universLabel;
      const desc = dialog.querySelector('[data-dialog-desc]');
      desc.textContent = tile.dataset.desc || '';
      desc.hidden = !tile.dataset.desc;
      dialog.showModal();
      dialog.scrollTop = 0;
      if (tile.id) history.replaceState({}, '', `#${tile.id}`);
    };
    const close = () => dialog.close();
    root.querySelectorAll('[data-patch-open]').forEach(btn => btn.addEventListener('click', () => open(btn.closest('[data-patch-tile]'), btn)));
    dialog.querySelectorAll('[data-dialog-close]').forEach(btn => btn.addEventListener('click', close));
    dialog.addEventListener('click', e => { if (e.target === dialog) close(); });
    dialog.addEventListener('close', () => {
      history.replaceState({}, '', location.pathname + location.search);
      if (opener) opener.focus({ preventScroll: true });
    });

    /* Ouverture directe depuis un lien de l’accueil (#nom-du-patch), au chargement
       comme lors d’un changement d’ancre sur la page. */
    const openFromHash = () => {
      if (!location.hash || dialog.open) return;
      let tile = null;
      try { tile = root.querySelector(`#${CSS.escape(decodeURIComponent(location.hash.slice(1)))}[data-patch-tile]`); } catch (e) { tile = null; }
      const trigger = tile && tile.querySelector('[data-patch-open]');
      if (trigger) {
        tile.scrollIntoView({ block: 'center' });
        setTimeout(() => open(tile, trigger), 250);
      }
    };
    openFromHash();
    window.addEventListener('hashchange', openFromHash);
  };
  const boot = () => document.querySelectorAll('[data-catalog]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-catalog]')));
})();
